import { Dialog, Icon, Icons, Intent } from "construct-ui";
import moment from "moment";
import DatePickerComponent from "../../components/date-picker/date-picker.component";
import FileUploadInputComponent from "../../components/file/file-upload-input.component";
import SelectCommonSearchInputComponent from "../../components/posm/common-search/common-search-input.component";
import AddRetailerComponent from "../../components/posm/goods-movement/add-retailer.component";
import DecimalNumbeInputComponent from "../../components/posm/goods-movement/decimal-number-input.component";
import QtyNumberInputComponent from "../../components/posm/goods-movement/qty-number-input.component";
import SingleSelectComponent from "../../components/single-select/single-select.component";
import SelectSiteSearchInputComponent from "../../components/site/select-site-search-input.component";
import SelectUserComponent from "../../components/user/select-user.component";
import { COMMON_SEARCH_DATA_TYPES, formats } from "../../config/constants";
import loginModel from "../../models/login.model";
import goodMovementModel from "../../models/posm/goods-movement.model";
import POSMAuthorizationModel, { POSM_PERMISSION_KEY } from "../../models/posm/posm-authority.model";
import { DEFAULT_MAX_QTY, MOVEMENT_TYPES } from "../../models/posm/posm.constant";
import ViewBase from "../view-base.view";

const isHQOrRHQ = (vendor) => {
  return vendor === 'HQ' || vendor === 'RHQ'
}

function Filters() {
  ViewBase.call(this);
  let toStorageLocations = [];

  const getAllStorageLocation = (toWarehouseId, fromStorageId) => {
    goodMovementModel.getCommonForPopup({ DataType: 'POSM_STORAGE', DataCode: "", DataName: "", ParameterDataCode: toWarehouseId })
      .then((data) => {
        toStorageLocations = data.data.filter(({ code }) => code != fromStorageId);
      }).catch((err) => {
        this.handleError(err);
      }).finally(() => {
        this.hideLoading()
      });
  }
  let isNewRetailSelected = false;
  let initChannelCode = null;
  return {
    oninit: ({ attrs: { movementDetailInfo } }) => {
      if (movementDetailInfo.toWarehouseId) {
        getAllStorageLocation(movementDetailInfo.toWarehouseId, movementDetailInfo.fromStorageId)
      }
      initChannelCode = movementDetailInfo.channelCode;
    },
    view: ({ attrs: { movementDetailInfo, onChange, maxQty } }) => {

      switch (movementDetailInfo.movementTypeCode) {
        case MOVEMENT_TYPES[0].code:
          return [m('.row.g-2',
            m('.col-md-4.position-relative',
              m('label.form-label[for="movementBy"]',
                this.getText('LT00001280', 'Receive By')
              ),
              m(SelectUserComponent, {
                default: {
                  userStatusCode: '0001'
                },
                multiple: false,
                onSelect: (selectedUserList) => {
                  onChange('movementBy', selectedUserList[0].userID);
                  onChange('movementByName', selectedUserList[0].userName);

                },
                selectedUserList: [{
                  userID: movementDetailInfo.movementBy,
                  userName: movementDetailInfo.movementByName
                }],
              })
            ),
            m('.col-md-4.position-relative',
              m('label.form-label.mandatory[for="movementDate"]',
                this.getText('LT00001281', 'Receive Date')
              ),
              m(DatePickerComponent, {
                class: 'form-control',
                required: true,
                readonly: true,
                date: moment(movementDetailInfo.movementDate).format(formats.dateFormat),
                onselect: (e) => {
                  onChange('movementDate', moment(e.detail.date).toISOString());
                }
              }),
              m('.invalid-tooltip', this.getText("LT00000729", "This field is required"))
            )
          ),
          m('.row.g-2',
            m('.col-md-4.position-relative',
              m('label.form-label.mandatory[for="fromVendor"]',
                this.getText('LT00001088', 'Vendor')
              ),
              m(SelectCommonSearchInputComponent, {
                required: true,
                dataType: COMMON_SEARCH_DATA_TYPES.VENDOR,
                selectedItem: { code: movementDetailInfo.fromVendorId, name: movementDetailInfo.fromVendor },
                onSelect: (selectedItem) => {
                  onChange('fromVendor', selectedItem.name);
                  onChange('fromVendorId', selectedItem.code);
                  if (isHQOrRHQ(movementDetailInfo.fromVendor)) {
                    onChange('unitPrice', 0);
                  }
                },
              }),
              m('.invalid-tooltip', this.getText("LT00000729", "This field is required"))
            )
          ),
          movementDetailInfo.isExpiry && m('.row.g-2',
            m('.col-md-4.position-relative',
              m('label.form-label.mandatory[for="expiryDate"]',
                this.getText('LT00001276', 'Use Due Date')
              ),
              m(DatePickerComponent, {
                class: 'form-control',
                required: movementDetailInfo.isExpiry,
                date: movementDetailInfo.goodsReceiveExpiryDate,
                readonly: true,
                onselect: (e) => {
                  onChange('goodsReceiveExpiryDate', e.detail.date);
                }
              }),
              m('.invalid-tooltip', this.getText("LT00000729", "This field is required"))
            )
          ),
          POSMAuthorizationModel.loadWithPOSMAuthority(
            m('.row.g-2',
              m('.col-md-6.position-relative',
                m('label.form-label[for="unitPrice"]', {
                  class: !isHQOrRHQ(movementDetailInfo.fromVendor) ? 'mandatory' : ''
                }, this.getText('LT00001282', 'Unit Price')),
                m(DecimalNumbeInputComponent, {
                  required: !isHQOrRHQ(movementDetailInfo.fromVendor),
                  disabled: isHQOrRHQ(movementDetailInfo.fromVendor),
                  value: movementDetailInfo.unitPrice,
                  onChange: (value) => {
                    if (isHQOrRHQ(movementDetailInfo.fromVendor)) {
                      onChange('unitPrice', 0);
                      return
                    }
                    onChange('unitPrice', value)
                  }
                })
              )
            ), POSM_PERMISSION_KEY.SHOW_PRICING_INFO),
          m('.row.g-2',
            m('.col-md-4.position-relative',
              m('label.form-label.mandatory[for="qty"]',
                this.getText('LT00001283', 'Qty')
              ),
              m(QtyNumberInputComponent, {
                placeholder: this.getText('LT00001283', 'Qty'),
                required: true,
                min: 1,
                max: DEFAULT_MAX_QTY,
                disabled: movementDetailInfo.editQtyYN !== 'Y',
                value: movementDetailInfo.movementQty,
                onChange: (value) => { onChange('movementQty', value) },
              })
            )
          )]

        case MOVEMENT_TYPES[1].code:
          return [m('.row.g-2',
            m('.col-md-4.position-relative',
              m('label.form-label[for="movementBy"]',
                this.getText('LT00001253', 'Move By')
              ),
              m(SelectUserComponent, {
                default: {
                  userStatusCode: '0001'
                },
                multiple: false,
                onSelect: (selectedUserList) => {
                  onChange('movementBy', selectedUserList[0].userID);
                  onChange('movementByName', selectedUserList[0].userName);
                },
                selectedUserList: [{
                  userID: movementDetailInfo.movementBy,
                  userName: movementDetailInfo.movementByName
                }],
              })
            ),
            m('.col-md-4.position-relative',
              m('label.form-label.mandatory[for="movementDate"]',
                this.getText('LT00001254', 'Movement Date')
              ),
              m(DatePickerComponent, {
                class: 'form-control',
                required: true,
                readonly: true,
                date: moment(movementDetailInfo.movementDate).format(formats.dateFormat),
                onselect: (e) => {
                  onChange('movementDate', moment(e.detail.date).toISOString());
                }
              }),
              m('.invalid-tooltip', this.getText("LT00000729", "This field is required"))
            )
          ),
          m('.row.g-2',
            m('.col-md-4.position-relative',
              m('label.form-label.mandatory[for="toWarehouse"]',
                this.getText('LT00001246', 'To Warehouse')
              ),
              m(SingleSelectComponent, {
                required: true,
                allowEmpty: goodMovementModel.warehouse.length != 0,
                items: goodMovementModel.warehouse,
                selectedItem: { code: movementDetailInfo.toWarehouseId?.toString(), name: movementDetailInfo.toWarehouse },
                onSelect: (selectedItem) => {
                  getAllStorageLocation(selectedItem.code, movementDetailInfo.fromStorageId)
                  onChange('toWarehouseId', selectedItem.code);
                  onChange('toWarehouse', selectedItem.name);
                  onChange('toStorageId', null)
                  onChange('toStorage', null)
                }
              }),
              m('.invalid-tooltip', this.getText("LT00000729", "This field is required"))
            )
          ),
          m('.row.g-2',
            m('.col-md-4.position-relative',
              m('label.form-label.mandatory[for="useDueDate"]',
                this.getText('LT00001247', 'To Storage Location')
              ),
              m(SingleSelectComponent, {
                required: true,
                allowEmpty: toStorageLocations.length != 0,
                items: toStorageLocations,
                selectedItem: { code: movementDetailInfo.toStorageId?.toString(), name: movementDetailInfo.toStorage },
                onSelect: (selectedItem) => {
                  onChange('toStorageId', selectedItem.code)
                  onChange('toStorage', selectedItem.name)
                }
              }),
              m('.invalid-tooltip', this.getText("LT00000729", "This field is required"))
            )
          ),
          m('.row.g-2',
            m('.col-md-4.position-relative',
              m('label.form-label.mandatory[for="qty"]',
                this.getText('LT00001283', 'Qty')
              ),
              m(QtyNumberInputComponent, {
                placeholder: this.getText('LT00001283', 'Qty'),
                required: true,
                min: 1,
                max: maxQty,
                disabled: movementDetailInfo.editQtyYN !== 'Y',
                value: movementDetailInfo.movementQty,
                onChange: (value) => { onChange('movementQty', value) },
              })
            )
          )]

        case MOVEMENT_TYPES[2].code:
          return [
            m('.row.g-2',
              m('.col-md-4.position-relative',
                m('label.form-label[for="movementBy"]',
                  this.getText('LT00001255', 'Issue By')
                ),
                m(SelectUserComponent, {
                  default: {
                    userStatusCode: '0001'
                  },
                  multiple: false,
                  onSelect: (selectedUserList) => {
                    onChange('movementBy', selectedUserList[0].userID);
                    onChange('movementByName', selectedUserList[0].userName);
                  },
                  selectedUserList: [{
                    userID: movementDetailInfo.movementBy,
                    userName: movementDetailInfo.movementByName
                  }],
                })
              ),
              m('.col-md-4.position-relative',
                m('label.form-label.mandatory[for="movementDate"]',
                  this.getText('LT00001256', 'Goods Issue Date')
                ),
                m(DatePickerComponent, {
                  class: 'form-control',
                  required: true,
                  readonly: true,
                  date: moment(movementDetailInfo.movementDate).format(formats.dateFormat),
                  onselect: (e) => {
                    onChange('movementDate', moment(e.detail.date).toISOString());
                  }
                }),
                m('.invalid-tooltip', this.getText("LT00000729", "This field is required"))
              )
            ),
            m(AddRetailerComponent, { movementDetailInfo, onChange, maxQty })
          ]

        case MOVEMENT_TYPES[3].code:
          let currentMaxQty = isNewRetailSelected ? movementDetailInfo.channelStockQty : maxQty
          return [
            m('.row.g-2',
              m('.col-md-4',
                m('label.form-label[for="movementBy"]',
                  this.getText('LT00001257', 'Return By')
                ),
                m(SelectUserComponent, {
                  default: {
                    userStatusCode: '0001'
                  },
                  multiple: false,
                  onSelect: (selectedUserList) => {
                    onChange('movementBy', selectedUserList[0].userID);
                    onChange('movementByName', selectedUserList[0].userName);
                  },
                  selectedUserList: [{
                    userID: movementDetailInfo.movementBy,
                    userName: movementDetailInfo.movementByName
                  }],
                })
              ),
              m('.col-md-4.position-relative',
                m('label.form-label.mandatory[for="movementDate"]',
                  this.getText('LT00001258', 'Goods Return Date')
                ),
                m(DatePickerComponent, {
                  class: 'form-control',
                  required: true,
                  readonly: true,
                  date: moment(movementDetailInfo.movementDate).format(formats.dateFormat),
                  onselect: (e) => {
                    onChange('movementDate', moment(e.detail.date).toISOString());
                  }
                }),
                m('.invalid-tooltip', this.getText("LT00000729", "This field is required"))
              )
            ),
            m('.row.g-2',
              m('.col-md-4.position-relative',
                m('label.form-label.mandatory[for="fromChannelCode"]', this.getText('LT00001259', 'From Retail')),
                m(SelectSiteSearchInputComponent, {
                  required: true,
                  multiple: false,
                  disabled: movementDetailInfo.editQtyYN !== 'Y',
                  selectedItem: { siteId: movementDetailInfo.channelCode, siteName: movementDetailInfo.channelName },
                  onSelect: (sites) => {
                    onChange('channelCode', sites.siteId);
                    onChange('channelName', sites.siteName);
                    goodMovementModel.getChannelGoodsQty({ channelCode: sites.siteId, basicModelId: movementDetailInfo.basicModelId })
                      .then((result) => {
                        onChange('channelStockQty', result.qty);
                        if (sites.siteId != initChannelCode) {
                          isNewRetailSelected = true;
                        }
                      }).catch((error) => {
                        this.handleError(error);
                      })
                  }
                }),
                m('.invalid-tooltip', this.getText("LT00000729", "This field is required"))
              ),
              m('.col-md-2.position-relative',
                m('label.form-label[for="retailQty"]', this.getText('LT00001260', 'Retail Qty')),
                m(`input#retailQty.form-control.form-control-bg[type=number][placeholder=${this.getText('LT00001260', 'Retail Qty')}]`, {
                  readonly: true,
                  disabled: true,
                  value: movementDetailInfo.channelStockQty,
                }
                ),
              ),
            ),
            m('.row.g-2',
              m('.col-md-4.position-relative',
                m('label.form-label.mandatory[for="qty"]',
                  this.getText('LT00001283', 'Qty')
                ),
                m(QtyNumberInputComponent, {
                  placeholder: this.getText('LT00001283', 'Qty'),
                  required: true,
                  min: 1,
                  max: currentMaxQty,
                  disabled: movementDetailInfo.editQtyYN !== 'Y',
                  value: movementDetailInfo.movementQty,
                  onChange: (value) => { onChange('movementQty', value) },
                }),
              )
            ),
            this.getBaseViews()
          ]

        case MOVEMENT_TYPES[4].code:
          return [
            m('.row.g-2',
              m('.col-md-4.position-relative',
                m('label.form-label[for="movementBy"]',
                  this.getText('LT00001261', 'Scrap By')
                ),
                m(SelectUserComponent, {
                  default: {
                    userStatusCode: '0001'
                  },
                  multiple: false,
                  onSelect: (selectedUserList) => {
                    onChange('movementBy', selectedUserList[0].userID);
                    onChange('movementByName', selectedUserList[0].userName);
                  },
                  selectedUserList: [{
                    userID: movementDetailInfo.movementBy,
                    userName: movementDetailInfo.movementByName
                  }],
                })
              ),
              m('.col-md-4.position-relative',
                m('label.form-label.mandatory[for="receiveDate"]',
                  this.getText('LT00001262', 'Scrap Date')
                ),
                m(DatePickerComponent, {
                  class: 'form-control',
                  required: true,
                  readonly: true,
                  date: moment(movementDetailInfo.movementDate).format(formats.dateFormat),
                  onselect: (e) => {
                    onChange('movementDate', moment(e.detail.date).toISOString());
                  }
                }),
                m('.invalid-tooltip', this.getText("LT00000729", "This field is required"))
              )
            ),
            m('.row.g-2',
              m('.col-md-4.position-relative',
                m('label.form-label.mandatory[for="qty"]',
                  this.getText('LT00001283', 'Qty')
                ),
                m(QtyNumberInputComponent, {
                  placeholder: this.getText('LT00001283', 'Qty'),
                  required: true,
                  min: 1,
                  max: maxQty,
                  disabled: movementDetailInfo.editQtyYN !== 'Y',
                  value: movementDetailInfo.movementQty,
                  onChange: (value) => { onChange('movementQty', value) },
                })
              )
            )
          ]
        default:
          return
      }
    }
  }

}
function CreatePOSMGoodsMovementDialog() {
  ViewBase.call(this);

  const FROM_STORAGE_TYPES = ['WM', 'GI', 'SC']
  const TO_STORAGE_TYPES = ['GR', 'RE']

  const UPDATE_GOODS_MOVEMENT_AUTHORITY_MAP = {
    'GR': POSM_PERMISSION_KEY.EDIT_GOODS_RECEIVE,
    'WM': POSM_PERMISSION_KEY.EDIT_GOODS_MOVEMENT,
    'GI': POSM_PERMISSION_KEY.EDIT_GOODS_ISSUE,
    'RE': POSM_PERMISSION_KEY.EDIT_GOODS_RETURN,
    'SC': POSM_PERMISSION_KEY.EDIT_SCRAP,
  }

  const CREATE_GOODS_MOVEMENT_AUTHORITY_MAP = {
    'GR': POSM_PERMISSION_KEY.GOODS_RECEIVE,
    'WM': POSM_PERMISSION_KEY.GOODS_MOVEMENT,
    'GI': POSM_PERMISSION_KEY.GOODS_ISSUE,
    'RE': POSM_PERMISSION_KEY.GOODS_RETURN,
    'SC': POSM_PERMISSION_KEY.SCRAP_GOODS,
  }

  const DEFAULT_MOVEMENT_DETAIL_INFO = {
    movementTypeCode: null,
    movementTypeName: null,
    movementControlCode: null,
    movementDate: null,
    mainName: null,
    mainCode: null,
    goodsTypeName: null,
    goodsTypeCode: null,
    divisionName: null,
    divisionCode: null,
    modelName: null,
    basicModelId: null,
    basicModelName: null,
    goodsControlId: null,
    movementQty: 0,
    stockQty: 0,
    mvgPrice: 0,
    refNo: null,
    fromVendor: null,
    fromVendorId: null,
    isExpiry: null,
    stockDueDate: null,
    expiryDate: null,
    fromWarehouse: null,
    fromWarehouseId: null,
    fromStorageId: null,
    fromStorage: null,
    channelCode: null,
    channelName: null,
    unitPrice: 0,
    goodsReceiveExpiryDate: null,
    toWarehouseId: null,
    toWarehouse: null,
    toStorageId: null,
    toStorage: null,
    remarks: null,
    fromStockQty: 0,
    toStockQty: 0,
    channelStockQty: 0,
    fileId1: null,
    fileName1: null,
    fileId2: null,
    fileName2: null,
    fileId3: null,
    fileName3: null,
    fileId4: null,
    fileName4: null,
    fileId5: null,
    fileName5: null,
    editQtyYN: null,
    createdDate: null,
    writtenBy: null,
    writtenByName: null,
    movementBy: null,
    movementByName: null,
    gaId: null,
    toChannelCode: [{ code: null, name: null, retailQty: 0, qty: 0 }]
  }

  const CREATE_GOODS_MOVEMENT_FORM_ID = 'CreateGoodsMovementForm'

  let movementDetailInfo = structuredClone(DEFAULT_MOVEMENT_DETAIL_INFO);
  let fileInputs = {
    1: null,
    2: null,
    3: null,
    4: null,
    5: null,
  }
  let isGetDataDone = false;
  const getGoodsMovementHeader = (payload) => {
    isGetDataDone = false

    this.showLoading();

    goodMovementModel.getGoodsMovementHeader(payload)
      .then((result) => {
        Object.assign(movementDetailInfo, {
          mainName: result.mainName,
          mainCode: result.mainId,
          basicModelId: result.basicModelId,
          basicModelName: result.basicModelName,
          divisionCode: result.divisionId,
          divisionName: result.divisionName,
          expiryDate: result.expiryDate,
          isExpiry: result.expiryYN,
          goodsControlId: result.goodsControlId,
          goodsTypeCode: result.goodsTypeId,
          goodsTypeName: result.goodsTypeName,
          modelName: result.modelName,
          mvgPrice: result.mvgPrice,
          stockDueDate: result.stockDueDate,
          stockQty: result.stockQty,
          fromStorage: isFromStorage() ? result.storageLocationName : null,
          fromStorageId: isFromStorage() ? goodMovementModel.movementDetail.storageLocation?.code : null,
          toStorage: isToStorage() ? result.storageLocationName : null,
          fromStockQty: isFromStorage() ? result.storageLocationQty : null,
          toStockQty: isToStorage() ? result.storageLocationQty : null,
          fromWarehouse: isFromStorage() ? result.warehouseName : null,
          toWarehouse: isToStorage() ? result.warehouseName : null,
          fromWarehouseId: isFromStorage() ? goodMovementModel.movementDetail.warehouse?.code : null,
          toWarehouseId: isToStorage() ? goodMovementModel.movementDetail.warehouse?.code : null,
          editQtyYN: 'Y',
          writtenByName: loginModel.credentials.username,
          createdDate: new Date().toISOString(),
          movementBy: loginModel.credentials.userID,
          movementByName: loginModel.credentials.username,
          movementDate: new Date().toISOString(),
          goodsReceiveExpiryDate: new Date().toISOString(),
        });
        checkUserMovementWarehouseMapAuthorization();
      }).catch((error) => {
        this.handleError(error);
      }).finally(() => {
        maxQty = calculateMaxQty(movementDetailInfo);
        isGetDataDone = true;
        this.hideLoading();
      })
  }

  const getGoodsMovementDetail = (movementControlCode, onClose) => {
    isGetDataDone = false
    this.showLoading();
    goodMovementModel.getGoodsMovementDetail({ movementControlCode })
      .then((result) => {
        if (result != null) {
          movementDetailInfo = result[0];
          handleChange('toChannelCode', result.map(({ channelCode, channelName, channelStockQty, movementQty }) => ({
            code: channelCode,
            name: channelName,
            retailQty: channelStockQty,
            qty: movementQty
          })))
          checkUserMovementWarehouseMapAuthorization()
        } else {
          let labelString = this.getText('EM00000834', 'Movement ID: ${$.movementControlCode} does not exist.');
          labelString = labelString.replace('${$.movementControlCode}', movementControlCode)

          this.showErrorMessage(labelString, '', () => { onClose(true) })
        }
      }).catch((error) => {
        this.handleError(error);
      }).finally(() => {
        maxQty = calculateMaxQty(movementDetailInfo);
        isGetDataDone = true;
        this.hideLoading();
      })
  }

  const buildCreateMovementBody = () => {
    const payload = {
      movementType: movementDetailInfo.movementTypeCode,
      basicModelId: movementDetailInfo.basicModelId,
      fromVendor: movementDetailInfo.fromVendor,
      fromStorageCode: movementDetailInfo.fromStorageId ? movementDetailInfo.fromStorageId : goodMovementModel.movementDetail.storageLocation?.code,
      toStorageCode: movementDetailInfo.movementTypeCode === 'WM' ? movementDetailInfo.toStorageId : goodMovementModel.movementDetail.storageLocation?.code,
      fromChannelCode: movementDetailInfo.channelCode,
      toChannelCode: movementDetailInfo.toChannelCode,
      qty: movementDetailInfo.movementQty,
      unitPrice: movementDetailInfo.unitPrice,
      refNo: movementDetailInfo.refNo,
      movementDate: moment(movementDetailInfo.movementDate).format(formats.apiDateFormat),
      movementBy: movementDetailInfo.movementBy,
      expiryDate: movementDetailInfo.isExpiry ? moment(movementDetailInfo.goodsReceiveExpiryDate).format(formats.apiDateFormat) : null,
      remarks: movementDetailInfo.remarks,
      fileInput1: fileInputs[1],
      fileInput2: fileInputs[2],
      fileInput3: fileInputs[3],
      fileInput4: fileInputs[4],
      fileInput5: fileInputs[5]
    }
    let payloadFormData = new FormData();
    Object.entries(payload).forEach(([key, value]) => {
      if (value || value == 0) {
        if (key === 'toChannelCode') {
          if (goodMovementModel.movementDetail.movementType.code === 'GI') {
            value.forEach((item, index) => {
              payloadFormData.append(`toChannelCode[${index}].Code`, item.code);
              payloadFormData.append(`toChannelCode[${index}].Qty`, item.qty);
            })
          }
        } else payloadFormData.append(key, value)
      }
    })

    return payloadFormData
  }
  const buildUpdateMovementBody = () => {
    const payload = {
      movementType: movementDetailInfo.movementTypeCode,
      movementControlId: movementControlCode,
      fromVendor: movementDetailInfo.fromVendor,
      fromStorageId: movementDetailInfo.fromStorageId,
      fromChannelCode: movementDetailInfo.channelCode,
      toStorageId: movementDetailInfo.toStorageId,
      toChannelCode: movementDetailInfo.toChannelCode,
      qty: movementDetailInfo.movementQty,
      unitPrice: movementDetailInfo.unitPrice,
      refNo: movementDetailInfo.refNo,
      movementDate: moment(movementDetailInfo.movementDate).format(formats.apiDateFormat),
      movementBy: movementDetailInfo.movementBy,
      expiryDate: movementDetailInfo.isExpiry ? moment(movementDetailInfo.goodsReceiveExpiryDate).format(formats.apiDateFormat) : null,
      remarks: movementDetailInfo.remarks,
      fileInput1: fileInputs[1],
      fileInput2: fileInputs[2],
      fileInput3: fileInputs[3],
      fileInput4: fileInputs[4],
      fileInput5: fileInputs[5],
      fileId1: movementDetailInfo.fileId1,
      fileId2: movementDetailInfo.fileId2,
      fileId3: movementDetailInfo.fileId3,
      fileId4: movementDetailInfo.fileId4,
      fileId5: movementDetailInfo.fileId5,
    }
    let payloadFormData = new FormData();
    Object.entries(payload).forEach(([key, value]) => {
      if (value || value == 0) {
        if (key === 'toChannelCode') {
          if (movementDetailInfo.movementTypeCode === 'GI') {
            value.forEach((item, index) => {
              payloadFormData.append(`toChannelCode[${index}].Code`, item.code);
              payloadFormData.append(`toChannelCode[${index}].Qty`, item.qty);
            })
          } else {
            payloadFormData.append(`toChannelCode[0].Code`, '');
            payloadFormData.append(`toChannelCode[0].Qty`, 0);
          }
        } else payloadFormData.append(key, value)
      } else {
        payloadFormData.append(key, '');
      }
    })

    return payloadFormData
  }

  const manualValidate = () => {
    //For Movement Qty
    if (movementDetailInfo.movementTypeCode != 'GI' &&
      Number(movementDetailInfo.movementQty) == 0
    ) {
      return false;
    }

    //For Goods Issue
    if (movementDetailInfo.movementTypeCode == 'GI' &&
      movementDetailInfo.toChannelCode.some(item => item.qty == 0)
    ) {
      return false
    }
    //For Unit Price
    if (movementDetailInfo.movementTypeCode == 'GR' &&
      !isHQOrRHQ(movementDetailInfo.fromVendor) &&
      Number(movementDetailInfo.unitPrice) == 0
    ) {
      return false
    }

    return true;
  }

  const handleSubmit = (e, onClose) => {
    if (!this.validateForm(e)) {
      return
    }

    if (!manualValidate()) {
      return
    }

    this.showLoading();
    if (isOpenDetail()) {
      goodMovementModel.updateGoodsMovement(buildUpdateMovementBody())
        .then((result) => {
          if (result.transStatus === 'SUCCESS') {
            this.showMessage(this.getText("LT00001016", "Item edited successfully"), this.getText('EM00000004', 'Success'), () => onClose(true))
          } else this.showErrorMessage(result.code ?? result.message, this.getText("EM00000142", "Error"))
        }).catch((error) => {
          this.handleError(error);
        }).finally(() => {
          this.hideLoading();
        })
    } else {
      goodMovementModel.addGoodsMovement(buildCreateMovementBody())
        .then((result) => {
          if (result.transStatus === 'SUCCESS') {
            this.showMessage(this.getText("LT00001018", "Item added successfully"), this.getText('EM00000004', 'Success'), () => onClose(true))
          } else this.showErrorMessage(result.code ?? result.message, this.getText("EM00000142", "Error"))
        }).catch((error) => {
          this.handleError(error);
        }).finally(() => {
          this.hideLoading();
        })
    }
  }

  const downloadProofFile = (fileId, fileName) => {
    goodMovementModel.downloadProofFile(fileId, fileName)
  }

  const handleChange = (key, value) => {
    movementDetailInfo[key] = value
  }

  let movementControlCode = ''

  const isOpenDetail = () => {
    if (movementControlCode) return true;
    return false;
  }

  const isFromStorage = () => {
    return FROM_STORAGE_TYPES.includes(movementDetailInfo.movementTypeCode)
  }

  const isToStorage = () => {
    return TO_STORAGE_TYPES.includes(movementDetailInfo.movementTypeCode)
  }

  const showDeleteMessage = (onClose) => {
    this.showConfirm(
      this.getText('EM00000265', 'Are you sure you want to delete?'),
      `${this.getText('LT00000135', 'Delete')} - ${movementDetailInfo.movementControlCode}`,
      (action) => {
        if (action === 'YES') {
          handleDeleteMovement(onClose);
        }
      }
    )
  }

  const handleDeleteMovement = (onClose) => {
    this.showLoading();

    goodMovementModel.deleteGoodsMovement(movementControlCode)
      .then((result) => {
        if (result.transStatus === 'SUCCESS') {
          this.showMessage(this.getText("LT00001077", "Item deleted successfully"), this.getText('EM00000004', 'Success'), () => onClose(true))
        } else this.showErrorMessage(result.message, this.getText("EM00000142", "Error"))
      }).catch((error) => {
        this.handleError(error);
      }).finally(() => {
        this.hideLoading();
      })
  }

  let maxQty = 0

  const calculateMaxQty = (movementDetailInfo) => {
    switch (movementDetailInfo.movementTypeCode) {
      case MOVEMENT_TYPES[1].code:
        return movementDetailInfo.fromStockQty + movementDetailInfo.movementQty;

      case MOVEMENT_TYPES[2].code:
        return movementDetailInfo.fromStockQty + movementDetailInfo.toChannelCode.reduce((previousValue, currentValue) => previousValue + parseInt(currentValue.qty ? currentValue.qty : 0, 10), 0);

      case MOVEMENT_TYPES[3].code:
        return movementDetailInfo.channelStockQty + movementDetailInfo.movementQty;

      case MOVEMENT_TYPES[4].code:
        return movementDetailInfo.fromStockQty + movementDetailInfo.movementQty;

      default:
        return 0
    }
  }

  const generateDialogTitle = () => {
    if (isOpenDetail()) {
      return `${movementDetailInfo.movementTypeName} (${movementControlCode})`
    } else return `${this.getText('LT00000058', 'Create')} ${movementDetailInfo.movementTypeName}`
  }

  const loadSaveButton = (movementType) => {
    /*
      Show Price -> Can view
      Edit without Show Price -> Can't view, can't edit
      Edit with Show Price -> Can view, can edit
      Create without Show Price -> Can't view, can't create
      Create with Show Price -> Can view, can create
    */
    if (movementType !== 'GR' || POSMAuthorizationModel.posmAuthority[POSM_PERMISSION_KEY.SHOW_PRICING_INFO]) {
      return (
        isOpenDetail()
          ? POSMAuthorizationModel.posmAuthority[UPDATE_GOODS_MOVEMENT_AUTHORITY_MAP[movementType]]
          : POSMAuthorizationModel.posmAuthority[CREATE_GOODS_MOVEMENT_AUTHORITY_MAP[movementType]]
      ) && userMovementWarehouseMapAuthority
    }
    return false
  }

  let userMovementWarehouseMapAuthority = false;
  const checkUserMovementWarehouseMapAuthorization = () => {
    goodMovementModel.checkUserMovementWarehouseMapAuthorization({
      movementType: movementDetailInfo.movementTypeCode,
      warehouseID: isFromStorage() ? movementDetailInfo.fromWarehouseId : movementDetailInfo.toWarehouseId,
    })
      .then((result) => {
        userMovementWarehouseMapAuthority = result === 'Y';
      })
      .catch((error) => {
        this.handleError(error)
      })
  }

  return {
    oninit: (vnode) => {
      handleChange('movementTypeCode', goodMovementModel.movementDetail.movementType?.code)
      handleChange('movementTypeName', goodMovementModel.movementDetail.movementType?.name)
      movementControlCode = vnode.attrs.movementControlCode;

      if (isOpenDetail()) {
        getGoodsMovementDetail(movementControlCode, vnode.attrs.onClose)
      }
      else {
        getGoodsMovementHeader({
          basicModelId: goodMovementModel.movementDetail.basicModel?.id,
          storageCode: goodMovementModel.movementDetail.storageLocation?.code
        });
      }
    },
    view: ({ attrs: { isOpen, onClose } }) => {
      return m(Dialog, {
        isOpen,
        onClose,
        closeOnOutsideClick: false,
        closeOnEscapeKey: false,
        class: 'cui-dialog-xxl',
        title: generateDialogTitle(),
        content: [
          m('.card',
            m('.card-body',
              m('form.needs-validation[novalidate]', {
                id: CREATE_GOODS_MOVEMENT_FORM_ID,
                onsubmit: (e) => { handleSubmit(e, onClose) }
              },
                m('.row.g-2',
                  m('.col-md-4',
                    m('label.form-label[for="main"]',
                      this.getText('LT00001266', 'Main')
                    ),
                    m(`input#Main.form-control.form-control-bg.text-truncate[type=text]`,
                      {
                        disabled: true,
                        value: movementDetailInfo.mainName ?? this.getText('LT00000287', 'Home'),
                        title: movementDetailInfo.mainName ?? this.getText('LT00000287', 'Home')
                      }
                    )
                  ),
                  m('.col-md-4',
                    m('label.form-label[for="goodsType"]',
                      this.getText('LT00001267', 'Goods Type')
                    ),
                    m(`input#goodsType.form-control.form-control-bg.text-truncate[type=text]`,
                      {
                        disabled: true,
                        value: movementDetailInfo.goodsTypeName + (movementDetailInfo.goodsTypeCode ? `(${movementDetailInfo.goodsTypeCode})` : ''),
                        title: movementDetailInfo.goodsTypeName + (movementDetailInfo.goodsTypeCode ? `(${movementDetailInfo.goodsTypeCode})` : '')
                      }
                    )
                  ),
                  m('.col-md-4',
                    m('label.form-label[for="division"]',
                      this.getText('LT00000233', 'Division')
                    ),
                    m(`input#division.form-control.form-control-bg.text-truncate[type=text]`,
                      {
                        disabled: true,
                        value: movementDetailInfo.divisionName + (movementDetailInfo.divisionCode ? `(${movementDetailInfo.divisionCode})` : ''),
                        title: movementDetailInfo.divisionName + (movementDetailInfo.divisionCode ? `(${movementDetailInfo.divisionCode})` : '')
                      }
                    )
                  ),
                  m('.col-md-4',
                    m('label.form-label[for="model"]',
                      this.getText('LT00000717', 'Model')
                    ),
                    m(`input#model.form-control.form-control-bg.text-truncate[type=text]`,
                      {
                        disabled: true,
                        value: movementDetailInfo.modelName,
                        title: movementDetailInfo.modelName
                      }
                    )
                  ),
                  m('.col-md-4',
                    m('label.form-label[for="basicModel"]',
                      this.getText('LT00001268', 'Basic Model')
                    ),
                    m(`input#basicModel.form-control.form-control-bg.text-truncate[type=text]`,
                      {
                        disabled: true,
                        value: movementDetailInfo.basicModelName,
                        title: movementDetailInfo.basicModelName
                      }
                    )
                  ),
                  m('.col-md-4',
                    m('label.form-label[for="controlNo"]',
                      this.getText('LT00001272', 'Control No')
                    ),
                    m(`input#controlNo.form-control.form-control-bg.text-truncate[type=text]`,
                      {
                        disabled: true,
                        value: movementDetailInfo.goodsControlId
                      }
                    )
                  ),
                  m('.col-md-4',
                    m('label.form-label[for="totalQty"]',
                      this.getText('LT00001273', 'Total Qty')
                    ),
                    m(`input#totalQty.form-control.form-control-bg.text-truncate[type=text]`,
                      {
                        disabled: true,
                        value: movementDetailInfo.stockQty
                      }
                    )
                  ),
                  m('.col-md-4',
                    m('label.form-label[for="MVGPrice"]',
                      this.getText('LT00001274', 'MVG Price')
                    ),
                    m(`input#MVGPrice.form-control.form-control-bg.text-truncate[type=text]`,
                      {
                        disabled: true,
                        value: movementDetailInfo.mvgPrice,
                      }
                    )
                  ),
                  m('.col-md-4',
                    m('label.form-label[for="stockDueDate"]',
                      this.getText('LT00001275', 'Stock Due Date')
                    ),
                    m(`input#stockDueDate.form-control.form-control-bg.text-truncate[type=text]`,
                      {
                        disabled: true,
                        value: movementDetailInfo.stockDueDate ? moment(movementDetailInfo.stockDueDate).format(formats.dateFormat) : ''
                      }
                    )
                  ),

                  m('.col-md-4',
                    m('label.form-label[for="useDueDate"]',
                      this.getText('LT00001276', 'Use Due Date')
                    ),

                    m(`input#useDueDate.form-control.form-control-bg.text-truncate[type=text]`,
                      {
                        disabled: true,
                        value: (movementDetailInfo.isExpiry && movementDetailInfo.expiryDate) ? moment(movementDetailInfo.expiryDate).format(formats.dateFormat) : ''
                      }
                    )
                  ),
                  m('.col-md-4',
                    m('label.form-label[for="warehouse"]',
                      this.getText('LT00001269', 'Warehouse')
                    ),
                    m(`input#warehouse.form-control.form-control-bg.text-truncate[type=text]`,
                      {
                        disabled: true,
                        value: isFromStorage() ? movementDetailInfo.fromWarehouse : movementDetailInfo.toWarehouse,
                        title: isFromStorage() ? movementDetailInfo.fromWarehouse : movementDetailInfo.toWarehouse
                      }
                    )
                  ),
                  m('.col-md-4',
                    m('label.form-label[for="storageLocation"]',
                      this.getText('LT00001270', 'Storage Location')
                    ),
                    m(`input#storageLocation.form-control.form-control-bg.text-truncate[type=text]`,
                      {
                        disabled: true,
                        value: isFromStorage() ? movementDetailInfo.fromStorage : movementDetailInfo.toStorage,
                        title: isFromStorage() ? movementDetailInfo.fromStorage : movementDetailInfo.toStorage
                      }
                    )
                  ),
                  m('.col-md-4',
                    m('label.form-label[for="storageQty"]',
                      this.getText('LT00001277', 'Storage Qty')
                    ),
                    m(`input#storageQty.form-control.form-control-bg.text-truncate[type=text]`,
                      {
                        disabled: true,
                        value: isFromStorage() ? movementDetailInfo.fromStockQty : movementDetailInfo.toStockQty,
                      }
                    )
                  ),
                  m('.col-md-4',
                    m('label.form-label[for="writtenBy"]',
                      this.getText('LT00001278', 'Written By')
                    ),
                    m(`input#writtenBy.form-control.form-control-bg.text-truncate[type=text]`,
                      {
                        disabled: true,
                        value: movementDetailInfo.writtenByName,
                        title: movementDetailInfo.writtenByName
                      }
                    )
                  ),
                  m('.col-md-4',
                    m('label.form-label[for="writtenDate"]',
                      this.getText('LT00001285', 'Written Date')
                    ),
                    m(`input#writtenDate.form-control.form-control-bg.text-truncate[type=text]`,
                      {
                        disabled: true,
                        value: movementDetailInfo.createdDate ? moment(movementDetailInfo.createdDate).format(formats.dateFormat) : '',
                      }
                    )
                  ),
                  m('.col-md-4',
                    m('label.form-label[for="refNo"]',
                      this.getText('LT00001279', 'Ref No')
                    ),
                    m(`input#refNo.form-control.form-control-bg[type=text]`,
                      {
                        placeholder: this.getText('LT00001279', 'Ref No'),
                        value: movementDetailInfo.refNo,
                        maxlength: 50,
                        onchange: (e) => {
                          handleChange('refNo', e.target.value)
                        }
                      }
                    )
                  )
                ),
                isGetDataDone && m(Filters, { movementDetailInfo, onChange: handleChange, maxQty }),
                m('.row.g-2',
                  m('.col-md-8.position-relative',
                    m('label.form-label.[for="fileInput1"]',
                      { class: (!!!movementDetailInfo.fileId1 && (movementDetailInfo.movementTypeCode === 'GR' || movementDetailInfo.movementTypeCode === 'WM')) && 'mandatory' },
                      this.getText('LT00001248', 'Proof 1')
                    ),
                    m(FileUploadInputComponent, {
                      required: !!!movementDetailInfo.fileId1 && (movementDetailInfo.movementTypeCode === 'GR' || movementDetailInfo.movementTypeCode === 'WM'),
                      disabled: movementDetailInfo.fileId1,
                      accept: '.csv,.doc,.docx,.gif,.jpeg,.jpg,.png,.pdf,.ppt,.pptx,.svg,.xls,.xlsx,.txt',
                      requiredInvalidText: this.getText('LT00000729', 'This field is required'),
                      onInput: (uploadedFile) => {
                        fileInputs[1] = uploadedFile;
                      },
                    })
                  ),
                  m('.col-md-4.d-flex.align-items-end',
                    movementDetailInfo.fileId1 &&
                    [
                      m("button.btn.btn-link.text-truncate[type=button]", {
                        title: movementDetailInfo.fileName1,
                        onclick: () => {
                          downloadProofFile(movementDetailInfo.fileId1, movementDetailInfo.fileName1)
                        }
                      }, movementDetailInfo.fileName1),
                      m("button.btn.btn-link.px-0[type=button]",
                        m(Icon, {
                          intent: Intent.NEGATIVE,
                          name: Icons.X,
                          onclick: () => {
                            handleChange('fileId1', null);
                            handleChange('fileName1', null);
                          },
                          size: 'lg',
                        })
                      )
                    ]
                  )
                ),
                m('.row.g-2',
                  m('.col-md-8',
                    m('label.form-label[for="fileInput2"]',
                      this.getText('LT00001249', 'Proof 2')
                    ),
                    m(FileUploadInputComponent, {
                      accept: '.csv,.doc,.docx,.gif,.jpeg,.jpg,.png,.pdf,.ppt,.pptx,.svg,.xls,.xlsx,.txt',
                      disabled: movementDetailInfo.fileId2,
                      onInput: (uploadedFile) => {
                        fileInputs[2] = uploadedFile;
                      },
                    })
                  ),
                  m('.col-md-4.d-flex.align-items-end',
                    movementDetailInfo.fileId2 &&
                    [
                      m("button.btn.btn-link.text-truncate[type=button]", {
                        title: movementDetailInfo.fileName2,
                        onclick: () => {
                          downloadProofFile(movementDetailInfo.fileId2, movementDetailInfo.fileName2)
                        }
                      }, movementDetailInfo.fileName2),
                      m("button.btn.btn-link.px-0[type=button]",
                        m(Icon, {
                          intent: Intent.NEGATIVE,
                          name: Icons.X,
                          onclick: () => {
                            handleChange('fileId2', null);
                            handleChange('fileName2', null);
                          },
                          size: 'lg',
                        })
                      )
                    ]
                  )
                ),
                m('.row.g-2',
                  m('.col-md-8',
                    m('label.form-label[for="fileInput3"]',
                      this.getText('LT00001250', 'Proof 3')
                    ),
                    m(FileUploadInputComponent, {
                      accept: '.csv,.doc,.docx,.gif,.jpeg,.jpg,.png,.pdf,.ppt,.pptx,.svg,.xls,.xlsx,.txt',
                      disabled: movementDetailInfo.fileId3,
                      onInput: (uploadedFile) => {
                        fileInputs[3] = uploadedFile;
                      },
                    })
                  ),
                  m('.col-md-4.d-flex.align-items-end',
                    movementDetailInfo.fileId3 &&
                    [
                      m("button.btn.btn-link.text-truncate[type=button]", {
                        title: movementDetailInfo.fileName3,
                        onclick: () => {
                          downloadProofFile(movementDetailInfo.fileId3, movementDetailInfo.fileName3)
                        }
                      }, movementDetailInfo.fileName3),
                      m("button.btn.btn-link.px-0[type=button]",
                        m(Icon, {
                          intent: Intent.NEGATIVE,
                          name: Icons.X,
                          onclick: () => {
                            handleChange('fileId3', null);
                            handleChange('fileName3', null);
                          },
                          size: 'lg',
                        })
                      )
                    ]
                  )
                ),
                m('.row.g-2',
                  m('.col-md-8',
                    m('label.form-label[for="fileInput4"]',
                      this.getText('LT00001251', 'Proof 4')
                    ),
                    m(FileUploadInputComponent, {
                      accept: '.csv,.doc,.docx,.gif,.jpeg,.jpg,.png,.pdf,.ppt,.pptx,.svg,.xls,.xlsx,.txt',
                      disabled: movementDetailInfo.fileId4,
                      onInput: (uploadedFile) => {
                        fileInputs[4] = uploadedFile;
                      },
                    })
                  ),
                  m('.col-md-4.d-flex.align-items-end',
                    movementDetailInfo.fileId4 &&
                    [
                      m("button.btn.btn-link.text-truncate[type=button]", {
                        title: movementDetailInfo.fileName4,
                        onclick: () => {
                          downloadProofFile(movementDetailInfo.fileId4, movementDetailInfo.fileName4)
                        }
                      }, movementDetailInfo.fileName4),
                      m("button.btn.btn-link.px-0[type=button]",
                        m(Icon, {
                          intent: Intent.NEGATIVE,
                          name: Icons.X,
                          onclick: () => {
                            handleChange('fileId4', null);
                            handleChange('fileName4', null);
                          },
                          size: 'lg',
                        })
                      )
                    ]
                  )
                ),
                m('.row.g-2',
                  m('.col-md-8',
                    m('label.form-label[for="fileInput5"]',
                      this.getText('LT00001252', 'Proof 5')
                    ),
                    m(FileUploadInputComponent, {
                      accept: '.csv,.doc,.docx,.gif,.jpeg,.jpg,.png,.pdf,.ppt,.pptx,.svg,.xls,.xlsx,.txt',
                      disabled: movementDetailInfo.fileId5,
                      onInput: (uploadedFile) => {
                        fileInputs[5] = uploadedFile;
                      },
                    })
                  ),
                  m('.col-md-4.d-flex.align-items-end',
                    movementDetailInfo.fileId5 &&
                    [
                      m("button.btn.btn-link.text-truncate[type=button]", {
                        title: movementDetailInfo.fileName5,
                        onclick: () => {
                          downloadProofFile(movementDetailInfo.fileId5, movementDetailInfo.fileName5)
                        }
                      }, movementDetailInfo.fileName5),
                      m("button.btn.btn-link.px-0[type=button]",
                        m(Icon, {
                          intent: Intent.NEGATIVE,
                          name: Icons.X,
                          onclick: () => {
                            handleChange('fileId5', null);
                            handleChange('fileName5', null);
                          },
                          size: 'lg',
                        })
                      )
                    ]
                  )
                ),
                m('.row.g-2',
                  m('.col-md-8',
                    m('label.form-label[for="remarks"]',
                      this.getText('LT00000152', 'Remarks')
                    ),
                    m(`textarea#remarks.form-control.form-control-bg`,
                      {
                        placeholder: this.getText('LT00000152', 'Remarks'),
                        maxlength: 1000,
                        value: movementDetailInfo.remarks,
                        onchange: (e) => { handleChange('remarks', e.target.value) }
                      }
                    )
                  )
                )
              )
            )
          ),
          this.getBaseViews()
        ],

        footer: m('.row',
          m('.col-12.gap-2.d-flex.justify-content-end',
            loadSaveButton(movementDetailInfo?.movementTypeCode) &&
            m('button.btn.btn-primary',
              {
                type: 'submit',
                form: CREATE_GOODS_MOVEMENT_FORM_ID
              },
              this.getText('LT00000022', 'Save')
            ),
            isOpenDetail() && loadSaveButton(movementDetailInfo?.movementTypeCode) &&
            m('button.btn.btn-danger',
              {
                type: 'button',
                onclick: () => { showDeleteMessage(onClose) }
              },
              this.getText('LT00000135', 'Delete')
            ),
            m('button.btn.btn-white',
              {
                type: 'button',
                onclick: onClose,
              },
              this.getText('LT00000021', 'Close')
            )
          )
        ),
      })
    }
  }
}
export default CreatePOSMGoodsMovementDialog